import { render, staticRenderFns } from "./AppointmentManagementWrapper.vue?vue&type=template&id=51b8a51c"
import script from "./AppointmentManagementWrapper.vue?vue&type=script&lang=js"
export * from "./AppointmentManagementWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b8a51c')) {
      api.createRecord('51b8a51c', component.options)
    } else {
      api.reload('51b8a51c', component.options)
    }
    module.hot.accept("./AppointmentManagementWrapper.vue?vue&type=template&id=51b8a51c", function () {
      api.rerender('51b8a51c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/appointmentManagement/AppointmentManagementWrapper.vue"
export default component.exports